'use client';

import { useTranslations } from 'next-intl';
import BaseSidebarLayout from '@/components/common/BaseSidebarLayout';
import { useParams } from 'next/navigation';

type Props = {
    children: React.ReactNode;
};

export default function ContactsLayout({ children }: Props) {
    const params = useParams();
    const locale = params.locale as string;
    const t = useTranslations('ContactsPage');

    const menuItems = [
        { id: 'contacts', label: t('contacts'), href: `/${locale}/contacts` },
        { id: 'customer-service', label: t('customerService'), href: `/${locale}/contacts/customer-service` },
    ];

    return <BaseSidebarLayout menuItems={menuItems} title={t('title')}>{children}</BaseSidebarLayout>;
}
